import { render, staticRenderFns } from "./AcademicProgress.vue?vue&type=template&id=b8f05508"
import script from "./AcademicProgress.vue?vue&type=script&lang=js"
export * from "./AcademicProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports